export default "__VITE_ASSET__BP$sdJP2__"